import React from 'react'

import PlatformCheckboxBlock from './PlatformCheckboxBlock'

import {
  dv360AdAccountErrorSelector,
  dv360AdAccountIsLoadingSelector,
  dv360AdAccountSelector,
  dv360AdAccountWasLoadedSelector,
  facebookAdAccountErrorSelector,
  facebookAdAccountIsLoadingSelector,
  facebookAdAccountSelector,
  facebookAdAccountWasLoadedSelector,
  googleAdAccountErrorSelector,
  googleAdAccountIsLoadingSelector,
  googleAdAccountSelector,
  googleAdAccountWasLoadedSelector,
  tikTokAdAccountErrorSelector,
  tikTokAdAccountIsLoadingSelector,
  tikTokAdAccountSelector,
  tikTokAdAccountWasLoadedSelector
} from '../../../../../../modules/selectors/adAccounts'

import {
  DV360_AD_ACCOUNT_CHECKED,
  DV360_AD_ACCOUNT_DATA,
  DV360_AD_ACCOUNT_ID,
  FACEBOOK_AD_ACCOUNT_CHECKED,
  FACEBOOK_AD_ACCOUNT_DATA,
  FACEBOOK_AD_ACCOUNT_ID,
  GOOGLE_AD_ACCOUNT_CHECKED,
  GOOGLE_AD_ACCOUNT_DATA,
  GOOGLE_AD_ACCOUNT_ID,
  TIKTOK_AD_ACCOUNT_CHECKED,
  TIKTOK_AD_ACCOUNT_DATA,
  TIKTOK_AD_ACCOUNT_ID
} from '../fields'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../../../../constants/selectLists/platformList'

const AdAccountsSection = ({ formik, showAcceptTosLink }) => {
  return (
    <>
      <PlatformCheckboxBlock
        formik={formik}
        title="Facebook"
        checkboxFieldName={FACEBOOK_AD_ACCOUNT_CHECKED}
        adAccountFieldName={FACEBOOK_AD_ACCOUNT_ID}
        adAccountDataFieldName={FACEBOOK_AD_ACCOUNT_DATA}
        platform={FACEBOOK_PLATFORM}
        isLoadingSelector={facebookAdAccountIsLoadingSelector}
        dataSelector={facebookAdAccountSelector}
        wasLoadedSelector={facebookAdAccountWasLoadedSelector}
        errorSelector={facebookAdAccountErrorSelector}
        showAcceptTosLink={showAcceptTosLink}
      />
      <PlatformCheckboxBlock
        formik={formik}
        title="Google Ads"
        checkboxFieldName={GOOGLE_AD_ACCOUNT_CHECKED}
        adAccountFieldName={GOOGLE_AD_ACCOUNT_ID}
        adAccountDataFieldName={GOOGLE_AD_ACCOUNT_DATA}
        platform={GOOGLE_PLATFORM}
        isLoadingSelector={googleAdAccountIsLoadingSelector}
        dataSelector={googleAdAccountSelector}
        wasLoadedSelector={googleAdAccountWasLoadedSelector}
        errorSelector={googleAdAccountErrorSelector}
        showAcceptTosLink={showAcceptTosLink}
      />
      <PlatformCheckboxBlock
        formik={formik}
        title="Display Video 360"
        checkboxFieldName={DV360_AD_ACCOUNT_CHECKED}
        adAccountFieldName={DV360_AD_ACCOUNT_ID}
        adAccountDataFieldName={DV360_AD_ACCOUNT_DATA}
        platform={DV_360_PLATFORM}
        isLoadingSelector={dv360AdAccountIsLoadingSelector}
        dataSelector={dv360AdAccountSelector}
        wasLoadedSelector={dv360AdAccountWasLoadedSelector}
        errorSelector={dv360AdAccountErrorSelector}
        showAcceptTosLink={showAcceptTosLink}
      />
      <PlatformCheckboxBlock
        formik={formik}
        title="TikTok"
        checkboxFieldName={TIKTOK_AD_ACCOUNT_CHECKED}
        adAccountFieldName={TIKTOK_AD_ACCOUNT_ID}
        adAccountDataFieldName={TIKTOK_AD_ACCOUNT_DATA}
        platform={TIKTOK_PLATFORM}
        isLoadingSelector={tikTokAdAccountIsLoadingSelector}
        dataSelector={tikTokAdAccountSelector}
        wasLoadedSelector={tikTokAdAccountWasLoadedSelector}
        errorSelector={tikTokAdAccountErrorSelector}
        showAcceptTosLink={showAcceptTosLink}
      />
    </>
  )
}

export default AdAccountsSection
